import {createWebHashHistory, createRouter} from "vue-router";
import GraphView from "@/src/views/graph/GraphView";
import HomeView from "@/src/views/HomeView";
import OfflineView from "@/src/views/OfflineView";
import GraphNotFoundView from "@/src/views/GraphNotFoundView.vue";

import ChatBotAdminView from "@/src/views/chatbotAdmin/BaseView.vue";

export const ROUTE_NAMES = {
    HOME: "Home",
    OFFLINE: "Offline",
    STATUS: "Status",
    USER_MANAGEMENT: "UserManagement",
    SETTINGS: "Settings",
    CHATBOT_ADMIN: "ChatBotAdmin",
    PREFERENCES: "Preferences",
    GRAPH_NOT_FOUND: "GraphNotFound",
};

const routes = [
    {
        path: "/",
        name: ROUTE_NAMES.HOME,
        component: GraphView,
    },
    {
        path: "/chatbotadmin",
        name: ROUTE_NAMES.CHATBOT_ADMIN,
        component: ChatBotAdminView,
    },
    {
        path: "/offline",
        name: ROUTE_NAMES.OFFLINE,
        component: OfflineView,
        beforeEnter: (to, from, next) => {
            if (from.name === "Offline" || typeof from.name === "undefined") {
                next({name: "Home"});
            }
            next();
        },
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

router.beforeEach(async (to) => {
    return true;
});

export default router;
